import { CalendarRegular } from '@tamagui-extras/core'
import { Month, MonthProps } from './month'
import { MonthType } from '@datepicker-react/hooks'
import { DatePickerFieldProps } from './date-picker.props'
import { XStack } from 'tamagui'
import { Popover, PopoverProps } from '../../popover'
import { Button, ButtonProps } from '../../button'

type DatePickerPopoverProps = Omit<PopoverProps, 'trigger'> & {
  activeMonths: MonthType[]
  monthsCount: number
  firstDayOfWeek: MonthProps['firstDayOfWeek']
  labelFunctions: DatePickerFieldProps['labelFunctions']
  buttonProps?: ButtonProps
}

export function DatePickerPopover({
  activeMonths,
  monthsCount,
  firstDayOfWeek,
  labelFunctions,
  buttonProps,
  ...popoverProps
}: DatePickerPopoverProps) {
  return (
    <Popover
      isBouncy={true}
      {...popoverProps}
      contentProps={{
        padding: '$4',
        elevation: '$5',
        ...popoverProps?.contentProps,
      }}
      trigger={
        <Button
          theme="whiteGray"
          icon={<CalendarRegular />}
          borderTopLeftRadius={0}
          borderBottomLeftRadius={0}
          focusStyle={{
            outlineWidth: 0,
          }}
          {...buttonProps}
        />
      }
    >
      <XStack space alignItems={'flex-start'}>
        {activeMonths.map((month, index) => (
          <Month
            key={`${month.year}-${month.month}`}
            year={month.year}
            month={month.month}
            monthsCount={monthsCount}
            firstDayOfWeek={firstDayOfWeek}
            isFirst={monthsCount === 0 || index === 0}
            isLast={monthsCount === 0 || index === monthsCount - 1}
            {...labelFunctions}
          />
        ))}
      </XStack>
    </Popover>
  )
}
